<aura-avatar
  [srcImage]="$safeNavigationMigration(currentAvatar()?.url)"
  [label]="placeholder()"
  [size]="'3xl'"
/>
